import { createContext, useContext, useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ThemeContext = createContext();

// Routes that should use dark theme (finance/trading)
const darkRoutes = ['/trading', '/portfolio', '/financial-consulting', '/dashboard'];

// Routes that should use light theme (fashion/art)
const lightRoutes = ['/fashion', '/art-gallery', '/media-services'];

export function ThemeProvider({ children }) {
  const [theme, setTheme] = useState('dark');
  
  // Set theme based on current route
  const updateThemeForRoute = (pathname) => {
    if (darkRoutes.some(route => pathname.startsWith(route))) {
      setTheme('dark');
    } else if (lightRoutes.some(route => pathname.startsWith(route))) {
      setTheme('light');
    } else {
      // Default to dark for landing and other pages
      setTheme('dark');
    }
  };
  
  // Manual theme toggle
  const toggleTheme = () => {
    setTheme(prev => prev === 'dark' ? 'light' : 'dark');
  };
  
  // Apply theme to document
  useEffect(() => {
    const root = document.documentElement;
    if (theme === 'dark') {
      root.classList.add('dark');
      root.classList.remove('light');
    } else {
      root.classList.remove('dark');
      root.classList.add('light');
    }
  }, [theme]);
  
  return (
    <ThemeContext.Provider value={{ theme, setTheme, toggleTheme, updateThemeForRoute }}>
      {children}
    </ThemeContext.Provider>
  );
}

export function useTheme() {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
}
